import React, { FC } from 'react'
import styled from 'styled-components'

import { Text, Title } from '../CssStyled'
import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../../interfaces'
import { Icon } from '@wirtualna-polska/n2cr-ds'
import CloseStrokeIcon from './CloseStroke'
import CurvyLine5Icon from './CurvyLine'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import AdsLogo from '@ads/front-core/Icons/AdsLogo'
import { advantages } from './utils'
import { Trans } from '@ads/front-core/locales'

const AdvantagesOfWpADS: FC<ISection> = ({ setActiveMenu }) => (
  <InfinityObserver callback={() => setActiveMenu('advantages')}>
    <Container>
      <TitleStyled>
        <Trans
          i18nKey="landing:whyIsItWorthToUseWpAds"
          components={{ bold: <Title bold /> }}
        />
      </TitleStyled>
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <ThDesktopPlug />
              <Th>
                <Text>Meta</Text>
              </Th>
              <Th>
                <Text>Google</Text>
              </Th>
              <Th>
                <AdsLogoLPIcon />
              </Th>
            </tr>
          </thead>
          <tbody>
            {advantages.map(item => (
              <React.Fragment key={item.name}>
                <TrNameMobileWrapper>
                  <Td colSpan={3}>
                    <Text>{item.name}</Text>
                  </Td>
                </TrNameMobileWrapper>
                <Tr>
                  <TdNameDesktop>
                    <Text>{item.name}</Text>
                  </TdNameDesktop>
                  <Td>
                    {item.meta ? (
                      <IconStyled name="20-check-stroke" />
                    ) : (
                      <CloseStrokeIcon />
                    )}
                  </Td>
                  <Td>
                    {item.google ? (
                      <IconStyled name="20-check-stroke" />
                    ) : (
                      <CloseStrokeIcon />
                    )}
                  </Td>
                  <Td>
                    {typeof item.wpAds === 'boolean' ? (
                      item.wpAds ? (
                        <IconStyled name="20-check-stroke" />
                      ) : (
                        <CloseStrokeIcon />
                      )
                    ) : (
                      <Text>{item.wpAds}</Text>
                    )}
                  </Td>
                </Tr>
              </React.Fragment>
            ))}
          </tbody>
        </Table>

        <CurvyLine5IconWrapper>
          <CurvyLine5Icon />
        </CurvyLine5IconWrapper>
      </TableWrapper>
    </Container>
  </InfinityObserver>
)

const Container = styled.div`
  position: relative;
  padding: 60px 0;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    right: 50%;
    width: 100vw;
    margin-left: -50vw;
    margin-right: -50vw;
    bottom: 0;
    top: 0;
    background-color: #f3f4f6;
    z-index: -1;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    &:before {
      content: none;
    }
  }
`

const TitleStyled = styled(Title)`
  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const TableWrapper = styled.div`
  position: relative;
  margin: 42px 82px 0;
  padding: 16px 32px;
  border: 1px solid #e6e8ed;
  border-radius: 8px;
  background-color: #ffffff;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin: 0;
    padding: 0;
    border: none;
  }
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  @media (max-width: ${breakpoints.MOBILE}) {
    table-layout: fixed;
  }
`
const Tr = styled.tr`
  height: 84px;
  border-top: 1px solid #e6e8ed;

  @media (max-width: ${breakpoints.MOBILE}) {
    width: 50px;
    height: 50px;
  }
`

const Th = styled.th`
  width: 200px;
  padding: 38px 0;

  @media (max-width: ${breakpoints.MOBILE}) {
    width: 50px;
  }
`

const ThDesktopPlug = styled.th`
  display: block;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const Td = styled.td`
  text-align: center;

  &:first-child {
    text-align: left;
  }

  svg {
    width: 40px;
    height: 40px;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    svg {
      width: 28px;
      height: 28px;
    }
  }
`

const TdNameDesktop = styled.td`
  padding-left: 16px;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const TrNameMobileWrapper = styled.tr`
  display: none;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: table-row;
    border-top: 1px solid rgb(230, 232, 237);

    td {
      text-align: start;
      padding: 8px 0;
    }
  }
`

const IconStyled = styled(Icon)`
  color: #262a44;
`

const CurvyLine5IconWrapper = styled.div`
  position: absolute;
  top: -176px;
  right: -64px;
  z-index: -1;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const AdsLogoLPIcon = styled(AdsLogo)`
  width: 134px;

  @media (max-width: ${breakpoints.MOBILE}) {
    width: 76px;
  }
`

export default AdvantagesOfWpADS
